import { FormattedMessage } from "react-intl";
import { Heading, Skeleton, Text } from "@lendcord/concord";

// Mirrors DocumentsSection's static labels/headings with each
// DocumentUploadSlot placeholder reduced to a button-sized skeleton (a slot's
// real height varies with document count, so this matches the common
// no-documents-yet baseline rather than an exact shape).
export function DocumentsSectionSkeleton() {
  return (
    <div className="flex flex-col gap-8">
      <Heading level={3}>
        <FormattedMessage id="lender.profile.uploadDocumentsHeading" />
      </Heading>

      <div className="flex flex-col gap-4">
        <Text as="p" size="sm" className="font-medium">
          <FormattedMessage id="lender.profile.documentTypePan" />
        </Text>
        <Skeleton variant="rect" className="h-9 w-32" />
      </div>

      <div className="flex flex-col gap-4">
        <Text as="p" size="sm" className="font-medium">
          <FormattedMessage id="lender.profile.documentTypeAddressProof" />
        </Text>
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2">
            <Text as="p" size="xs" variant="muted">
              <FormattedMessage id="lender.profile.documentUploadAadhaarFront" />
            </Text>
            <Skeleton variant="rect" className="h-9 w-32" />
          </div>
          <div className="flex flex-col gap-2">
            <Text as="p" size="xs" variant="muted">
              <FormattedMessage id="lender.profile.documentUploadAadhaarBack" />
            </Text>
            <Skeleton variant="rect" className="h-9 w-32" />
          </div>
        </div>
      </div>
    </div>
  );
}
